import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgArrowUp(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M17.2502 7.01782L24.0002 13.7678L25.768 12L16.8841 3.11612C16.6496 2.8817 16.3317 2.75 16.0002 2.75C15.6687 2.75 15.3507 2.8817 15.1163 3.11612L6.23242 12L8.00019 13.7678L14.7502 7.01771V29.2501H17.2502V7.01782Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgArrowUp);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
